// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Image from "components/layout/Image";
import Link from "components/layout/Link";

// #####################################################

export const StyledLink = styled(Link)`
	display: inline-block;
	overflow: hidden;
	transition: transform 100ms;

	${Image} {
		transition: transform 100ms;
		transform: scale(1);
	}

	&:hover,
	&:focus {
		${Image} {
			transform: scale(1.05);
		}
	}

	background-color: ${({ theme: { isDarkMode } }) =>
		isDarkMode
			? "var(--dz-ref-color-gray300)"
			: "var(--dz-ref-color-gray100)"};
	overflow: hidden;
`;

// #####################################################
